import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-service-account',
  templateUrl: './service-account.component.html',
  styleUrls: ['./service-account.component.css']
})
export class ServiceAccountComponent {
  serviceAccountJson = "";
  projectName = "";
  showMessage = false;
  message = "";
  alertType: number = 1;
  modalTitle = "Add Service Account";
  serviceAccounts: any[] = []
  selectedServiceAccount: any;
  showSpinner = true;

  constructor(private titleService: Title,
    private userApiService: UserApiService,
    @Inject(DOCUMENT) private document: Document) {
    this.titleService.setTitle("Manage Service Accounts | Rankahead.app");
  }

  ngOnInit() {
    this.getServiceAccounts();
  }

  clearValues() {
    this.serviceAccountJson = "";
    this.projectName = "";
    this.selectedServiceAccount = null;
    this.modalTitle = "Add Service Account";
  }

  addOrUpdateServiceAccount() {
    
    if (this.modalTitle == "Add Service Account") {
      this.userApiService.postServiceAccount(this.serviceAccountJson, this.projectName).subscribe(response => {
        this.closeModals();
        this.getServiceAccounts();
        this.showAlert(1, "Service account have been successfully saved.");
        
      }, error => {
        this.showAlert(0, "An error occured while submitting service account");
      })
    }
    else {
      this.userApiService.putServiceAccount(this.selectedServiceAccount.id, this.serviceAccountJson, this.projectName).subscribe(response => {
        this.closeModals();
        this.getServiceAccounts();
        this.showAlert(1, "Service account have been successfully updated.");
        
      }, error => {
        this.showAlert(0, "An error occured while updating service account");
      })
    }

  }

  getServiceAccounts() {
    this.userApiService.getServiceAccounts().subscribe(response => {
      this.serviceAccounts = response as [];
      this.showSpinner = false;
    })
  }

  deleteServiceAccount() {
    this.userApiService.deleteServiceAccount(this.selectedServiceAccount.id).subscribe(response => {
      this.closeModals();
      this.getServiceAccounts();
      this.showAlert(1, "Service account have been successfully deleted.");

    }, error => {
      this.showAlert(0, "An error occured while deleting service account");
    })
  }

  openUpdateModal(serviceAccount:any) {
    this.modalTitle = "Update Service Account";
    this.selectedServiceAccount = serviceAccount;
    this.serviceAccountJson = serviceAccount.json;
    this.projectName = serviceAccount.projectName;
  }

  openDeleteModal(serviceAccount: any) {
    this.selectedServiceAccount = serviceAccount;
    this.serviceAccountJson = serviceAccount.json;
    this.projectName = serviceAccount.projectName;
  }

  closeModals() {
    
    this.serviceAccountJson = "";
    this.projectName = "";
    this.selectedServiceAccount = null;
    let modals = this.document.getElementsByClassName("btn-modal-close");

    for (var i = 0; i < modals.length; i++) {
      (modals[i] as HTMLElement).click();
    }
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }
}
